import * as React from "react";
const SvgStatusUnfilled = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 1, cy: 2, r: 4, transform: "translate(10 10)", stroke: "currentColor", strokeWidth: 3, fill: "none" }));
export default SvgStatusUnfilled;
